ko.bindingHandlers["preventNewline"] =
   init: (element, valueAccessor) ->
      element.addEventListener 'keypress', (e) ->
         if e.key == "Enter" or e.which == 13
            e.preventDefault()